<template>
  <div>
    <ModalUpdateRRIM v-if="this.$store.getters.$GetModalCancel.rrimEdit" />
    <ModalViewRRIM v-if="this.$store.getters.$GetModalCancel.rrimView" :homologation="homologation" :role="role" />

    <ModalHomologa v-if="ModalHomologa">
      <div class="modal-header">
        <h3><strong>N° RRIM:</strong> {{ this.RRIM.rrim }}</h3>
        <h3><strong>Molde:</strong> {{ this.RRIM.molde }}</h3>
        <h3><strong>Cliente:</strong> {{ this.RRIM.Cliente }}</h3>
        <h3><strong>Criado por:</strong> {{ this.RRIM.criado }}</h3>
      </div>

      <div class="modal-comentario">
        <span><strong>Comentario:</strong></span>
        <textarea style="width: 100%" class="textarea_hom" v-model="ComentarioHomolgacao" rows="7">
        </textarea>
      </div>

      <div class="modal-buttons">
        <button class="btn-modal cancelar" @click="fecharModalHomolacao">Cancelar</button>
        <button class="btn-modal reprovar" @click="showModalConfirmacao(false)">
          Reprovar
        </button>
        <button class="btn-modal" @click="showModalConfirmacao(true)">
          Aprovar
        </button>
      </div>

      <div class="modal-confirmacao" v-if="showConfirmacao">
        <span v-if="statusHomologacao">Sim, eu desejo confirmar a <strong>APROVAÇÃO</strong> desta
          RRIM</span>
        <span v-if="!statusHomologacao">Sim, eu desejo confirmar a <strong>REPROVACAO</strong> desta
          RRIM</span>
        <div class="confirmacao-buttons">
          <!-- <button class="btn-modal sem-borda" @click="fecharModalHomolacao">
            Cancelar
          </button> -->
          <button class="btn-modal" @click="homologar(statusHomologacao, this.RRIM.rrim)">
            Sim, confirmar
          </button>
        </div>
      </div>
    </ModalHomologa>

    <div class="filters">
      <div class="searchInput">
        <div class="icon">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjY4NzIgMTkuMjg3TDE4LjIwODIgMTQuOTQzNEMxOC4wMDYgMTQuNzQ3NCAxNy43MzIgMTQuNjM4NCAxNy40NDQ0IDE0LjYzODRIMTYuNzEyMkMxNy45NTIxIDEzLjEwMDUgMTguNjg4OSAxMS4xNjYyIDE4LjY4ODkgOS4wNjE4OUMxOC42ODg5IDQuMDU2MDcgMTQuNTA2MyAwIDkuMzQ0NDMgMEM0LjE4MjUzIDAgMCA0LjA1NjA3IDAgOS4wNjE4OUMwIDE0LjA2NzcgNC4xODI1MyAxOC4xMjM4IDkuMzQ0NDMgMTguMTIzOEMxMS41MTQzIDE4LjEyMzggMTMuNTA5IDE3LjQwOTMgMTUuMDk0OSAxNi4yMDY4VjE2LjkxN0MxNS4wOTQ5IDE3LjE5NTggMTUuMjA3MiAxNy40NjE2IDE1LjQwOTMgMTcuNjU3NkwxOS44ODg0IDIyLjAwMTJDMjAuMzEwNyAyMi40MTA4IDIwLjk5MzUgMjIuNDEwOCAyMS40MTEzIDIyLjAwMTJMMjIuNjgyNyAyMC43NjgzQzIzLjEwNSAyMC4zNTg4IDIzLjEwNSAxOS42OTY1IDIyLjY4NzIgMTkuMjg3Wk05LjM0NDQzIDE0LjYzODRDNi4xNjgyMiAxNC42Mzg0IDMuNTk0MDEgMTIuMTQ2NCAzLjU5NDAxIDkuMDYxODlDMy41OTQwMSA1Ljk4MTcyIDYuMTYzNzMgMy40ODUzNCA5LjM0NDQzIDMuNDg1MzRDMTIuNTIwNiAzLjQ4NTM0IDE1LjA5NDkgNS45NzczNiAxNS4wOTQ5IDkuMDYxODlDMTUuMDk0OSAxMi4xNDIxIDEyLjUyNTEgMTQuNjM4NCA5LjM0NDQzIDE0LjYzODRaIiBmaWxsPSIjNkM2QzZDIi8+Cjwvc3ZnPgo="
            alt="" />
        </div>
        <div>
          <input style="border: none !important" type="text" placeholder="Pesquisar..." v-model="value_filter" />
        </div>
      </div>
      <div>
        <div class="filter-content">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjgyNyAwSDEuMTczMjRDMC4xMzIzMTkgMCAtMC4zOTI5MjUgMS4wODg5IDAuMzQ0NjI0IDEuNzI0NzhMOS4zNzUgOS41MTE1OFYxOC4xODYyQzkuMzc1IDE4LjUxNTggOS41NjE1NyAxOC44MjQ4IDkuODc0ODUgMTkuMDEzOUwxMy43ODExIDIxLjM3MDVDMTQuNTUxOCAyMS44MzU2IDE1LjYyNSAyMS4zNjQyIDE1LjYyNSAyMC41NDI4VjkuNTExNThMMjQuNjU1NiAxLjcyNDc4QzI1LjM5MTYgMS4wOTAxNiAyNC44NyAwIDIzLjgyNyAwWiIgZmlsbD0iIzQ0NDQ0NCIvPgo8L3N2Zz4K"
            alt="" />
          <div class="content-intern">
            <select v-model="filter_attr">
              <option value="Todos">Todos</option>
              <option value="id">Id</option>
              <option value="client">Cliente</option>
              <option value="mold">Molde</option>
            </select>
          </div>
        </div>
      </div>

      <button class="btn-filter" @click="filter">Filtrar</button>
    </div>

    <table class="table">
      <thead>
        <tr>
          <td colspan="col">RRIM</td>
          <td colspan="col">Molde</td>
          <td colspan="col">Cliente</td>
          <td colspan="col">Tipo de Molde</td>
          <td colspan="col">Data de Criação</td>
          <td colspan="col">Data de Abertura</td>
          <td colspan="col">Data de Tryout</td>
          <td colspan="col">Criado por:</td>
          <td colspan="col">Opções</td>
        </tr>
      </thead>
      <tbody class="tb-content">
        <tr v-for="tryouts in filtrarInput()" :key="tryouts.id">
          <td data-label="RRIM" class="tdTitle">{{ tryouts.rrim }}</td>
          <td data-label="Molde">{{ tryouts.molde }}</td>
          <td data-label="Cliente">{{ tryouts.Cliente }}</td>
          <td data-label="molde">
            <span v-if="tryouts.molde_family === 'true'"> Molde Familia</span>
            <span v-else> Molde Normal</span>
          </td>
          <td data-label="Data de Criação">{{ tryouts.Data }}</td>
          <td data-label="Data de Abertura">{{ tryouts.DataAbertura }}</td>
          <td data-label="Data de Tryout">
            {{ tryouts.DatadeTryout || "N/A" }}
          </td>
          <td data-label="Criado por:">
            {{ tryouts.criado }} <br />
            {{ tryouts.cargo }}
          </td>
          <td data-label="Opções">
            <div class="buttons-group">
              <button class="button3" @click="modal_view(tryouts.rrim)">
                <i class="fas fa-eye"></i> Visualizar
              </button>
              <button class="button4" type="button" @click="modal_edit(tryouts.rrim)"
                v-if="status_new_table && role !== 'eng_admin'">
                <i class="fas fa-edit"></i>
                Editar
              </button>
              <button class="button4" type="button" @click="AbrirModalHomologacao(tryouts)" v-if="role === 'eng_admin'">
                <i class="fa fa-check" aria-hidden="true"></i>
                Homologar
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <h2 v-if="filtrarInput().length === 0">Não há nada para ser mostrado</h2>
    <div style="display: flex; gap: 5px; align-items: center; height: 4rem">
      <button @click="init" v-if="currentPage !== 0" class="btn-pagination">
        Inicio
      </button>
      <button @click="back" v-if="currentPage !== 0" class="btn-pagination">
        Voltar
      </button>
      <span class="count"> Página {{ countPage }} de {{ countTotal }}</span>
      <button @click="next" class="btn-pagination" v-if="filtrarInput().length !== 0">
        Próximo
      </button>
    </div>
  </div>
</template>

<script>
import TableLite from "./../../components/Tables/Table-Simple.vue";
import {
  GetFindDataByIdRRIM,
  GetFindDataRRIMByAttr,
} from "../../controllers/RRIM/GetFindDataByIdRRIM";
import ModalViewRRIM from "../../components/Modais/ModalRRIM/ModalViewRRIM.vue";
import ModalUpdateRRIM from "../../components/Modais/ModalRRIM/ModalUpdateRRIM.vue";
import { GetAllRrimInRevisao } from "../../controllers/RRIM/GetAllRrimInRevisao";
import { api } from "../../http/index";
import ModalHomologa from "@/components/Modais/ModalHomologa.vue";
import dayjs from "dayjs";

// Orden de dados em forma Crescente
const sampleData1 = (offst, limit) => {
  offst = offst + 1;

  let data = [];
  for (let i = offst; i <= limit; i++) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

//Orden de dados em forma Decrescente
const sampleData2 = (offst, limit) => {
  let data = [];
  for (let i = limit; i > offst; i--) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

export default {
  name: "App",
  components: { TableLite, ModalViewRRIM, ModalUpdateRRIM, ModalHomologa },

  props: {
    configInputs: Number,
  },
  async created() {
    await this.requestList();
  },

  mounted() {
    this.role = this.$store.state.user.nivel_de_acesso.descricao;
  },

  data() {
    return {
      homologation: true,
      statusHomologacao: false,
      showConfirmacao: false,
      value_filter: null,
      filter_attr: "Todos",
      currentPage: 0,
      countPage: 1,
      datalength: 0,
      isActiveAprovado: false,
      isDisabledAprovado: false,
      isActiveReprovado: false,
      isDisabledReprovado: false,
      role: String,
      Data: [],
      RRIM: Number,
      ComentarioHomolgacao: null,
      ModalHomologa: false,
      Homolagacao: null,
      VerifyRRIM: false,
      VerifyEditRRIM: this.$store.getters.$GetModalCancel.rrimEdit,
      isLoading: false,
      valueSearch: "",
      id_rrim_homo: "",
      rows: [],
      rowsNowOk: [],
      totalRecordCount: 0,
      totalRecordCountNok: 0,
      status_new_table: true,
      sortable: {
        order: "id",
        sort: "asc",
      },
      countTotal: 1,
    };
  },

  methods: {
    showModalConfirmacao(valorConfirmacao) {
      this.statusHomologacao = valorConfirmacao;
      this.showConfirmacao = true;
    },

    async homologar(valorConfirmacao, rrim) {
      const Toast = await this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (
        this.ComentarioHomolgacao === null ||
        this.ComentarioHomolgacao.length === 0
      ) {
        Toast.fire({
          icon: "success",
          title: "Você deve adicionar um comentário!",
        });
      } else {
        if (valorConfirmacao) {
          await api
            .put(`/rrim/homologation/${rrim}`, {
              status: 2,
              comentario: this.ComentarioHomolgacao,
            })
            .then((res) => {
              Toast.fire({
                icon: "success",
                title: "RRIM Aprovada!",
              });
            });
        } else {
          await api
            .put(`/rrim/homologation/${rrim}`, {
              status: 3,
              comentario: this.ComentarioHomolgacao,
            })
            .then((res) => {
              Toast.fire({
                icon: "success",
                title: "RRIM Reprovada!",
              });
            });
        }

        window.location.reload();
      }
    },

    async requestList() {
      this.$store.commit("SetLoadingPattern", true); // insere o loading
      this.Data = [];
      const result = await GetAllRrimInRevisao(this.currentPage, 10, 1);
      await result.list.map((element) => {
        this.Data.push({
          rrim: element.ID,
          criado: `${element.homologacao[0].created_user.nome}`,
          cargo: element.homologacao[0].created_user.cargo,
          molde: element.MOLDE,
          molde_family: element.molde_familia,
          Cliente: element.CLIENTE,
          Data: this.ReformDate(element.DT_CHEGADA_MOLDE),
          DataAbertura: this.ReformDate(element.DT_ABERTURA_MOLDE),
          DatadeTryout: this.ReformDate(element.DT_TRYOUT_MOLDE),
        });
      });
      this.countTotal = result.countTotal / 10;
      if (!Number.isInteger(this.countTotal)) {
        const npage = Math.round(this.countTotal);
        this.countTotal = npage;
      }
      this.datalength = result.length;
      await this.doSearch(0, 10, "description", "asc");
      this.$store.commit("SetLoadingPattern", false); // insere o loading
    },

    async init() {
      this.currentPage = 0;
      this.countPage = 0;
      await this.requestList();
    },

    async back() {
      this.currentPage = this.currentPage - 10;
      thos.countPage--;
      await this.requestList();
    },

    async next() {
      this.currentPage = this.currentPage + 10;
      this.countPage++;
      await this.requestList();
    },

    async modal_view(rrim) {
      const result = await GetFindDataByIdRRIM(rrim);
      await this.$store.commit("MutationGetFindDataRRIM", result.data);
      this.$store.commit("MutationSetCancelModalViewRRIM", true);
    },
    async modal_edit(rrim) {
      const result = await GetFindDataByIdRRIM(rrim);
      await this.$store.commit("MutationGetFindDataRRIM", result.data);
      this.$store.commit("MutationSetCancelModalEditRRIM", true);
    },
    async AbrirModalHomologacao(rrim) {
      this.RRIM = rrim;
      this.ModalHomologa = true;
    },
    async fecharModalHomolacao() {
      this.showConfirmacao = false;
      this.isActiveAprovado = false;
      this.isDisabledAprovado = false;
      this.ComentarioHomolgacao = "";
      this.ModalHomologa = false;
      return;
    },

    homologacao(value) {
      if (value) {
        this.isActiveAprovado = true;
        this.isDisabledAprovado = false;
      } else {
        this.isActiveAprovado = false;
        this.isDisabledAprovado = true;
      }

      this.Homolagacao = value;
    },
    async ConfirmHomologacao(rrim) {
      if (this.Homolagacao == null || this.ComentarioHomolgacao == null) {
        const Toast = await this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "info",
          title: "Campos vazios ou não selecionados!",
        });

        return;
      }
      if (this.Homolagacao === true) {
        const result = await api.put(`/rrim/homologation/${rrim}`, {
          status: 2,
          comentario: this.ComentarioHomolgacao,
        });
        if (result.status === 200) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Aprovado com Sucesso!",
          });

          this.isActiveAprovado = false;
          this.isDisabledAprovado = false;
          this.ComentarioHomolgacao = "";
          window.location.reload();
        }
      } else {
        const result = await api.put(`/rrim/homologation/${rrim}`, {
          status: 3,
          comentario: this.ComentarioHomolgacao,
        });
        if (result.status === 200) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Reprovado com Sucesso!",
          });

          this.isActiveAprovado = false;
          this.isDisabledAprovado = false;
          this.ComentarioHomolgacao = "";
          window.location.reload();
        }
      }
    },
    // Montagem de filro e limite do checklist
    async doSearch(offset, limit, order, sort) {
      if (!this.isLoading) {
        this.isLoading = true;
      }

      this.status_new_table = false;
      this.status_new_table = true;

      setTimeout(() => {
        const limitePre = this.datalength;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rows = sampleData1(offset, limit);
        } else {
          this.rows = sampleData2(offset, limit);
        }

        this.totalRecordCount = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    // Montagem de filro e limite de Itens Não/Ok
    doSearch_NaoOK(offset, limit, order, sort) {
      this.isLoadingNok = true;
      setTimeout(() => {
        const limitePre = this.Data.length;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rowsNowOk = sampleData1(offset, limit);
        } else {
          this.rowsNowOk = sampleData2(offset, limit);
        }

        this.totalRecordCountNok = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    ReformDate(date) {
      const data = dayjs(date).add(1, "day").format("DD/MM/YYYY");

      return data;
    },

    async exportar(id) {
      const toast = await this.$swal
        .fire({
          title: "Deseja exportar RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      this.$router.push({ path: "/export", query: { id } });
    },

    filtrarInput() {
      let list = [];
      this.valueSearch = this.valueSearch.toLocaleLowerCase();
      list = this.Data.filter((filter) => {
        let rrimCodeFormated = String(filter.rrim);
        return (
          rrimCodeFormated.toLowerCase().match(this.valueSearch) ||
          filter.molde.toLowerCase().match(this.valueSearch) ||
          filter.Cliente.toLowerCase().match(this.valueSearch) ||
          filter.criado.toLowerCase().match(this.valueSearch)
        );
      });
      return list;
    },

    async filter() {
      if (this.filter_attr == "Todos") {
        await this.requestList();
      } else {
        const result = await GetFindDataRRIMByAttr(
          this.filter_attr,
          this.value_filter,
          1
        );

        this.Data = [];
        await result.data.map((element) => {
          this.Data.push({
            rrim: element.ID,
            criado: `${element.homologacao[0].created_user.nome}`,
            cargo: element.homologacao[0].created_user.cargo,
            molde: element.MOLDE,
            Cliente: element.CLIENTE,
            Data: this.ReformDate(element.DT_CHEGADA_MOLDE),
            DataAbertura: this.ReformDate(element.DT_ABERTURA_MOLDE),
            DatadeTryout: this.ReformDate(element.DT_TRYOUT_MOLDE),
          });
        });
      }
    },
  },
};
</script>
<style scoped>
input:disabled,
select:disabled,
textarea:disabled {
  background: #66666621;
}

img {
  border-style: none;
}

.buttonConfirm {
  color: red;
}

.searchInput {
  margin-top: 10px;
  width: 400px;
  background-color: var(--white);
  height: 2.8rem;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid var(--gray_text);
}

.btn-pagination {
  border: none;
  background-color: var(--green);
  padding: 0.5rem;
  color: var(--white);
  border-radius: 0.25rem;
}

.filter-content .content-intern {
  width: 80%;
  padding: 0 0 0 5px;
}

.filter-content .content-intern select {
  width: 100%;
  border: none;
  font-size: 15px;
  text-align: left;
}

.filters {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-filter {
  width: 70px;
  height: 2.8rem;
  background-color: var(--green);
  color: #fff;
  border-radius: 0.25rem;
}

.searchInput .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.searchInput input {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  width: 100%;
  border: none;
  border-radius: 5px;
}

.searchInput ::placeholder {
  color: #9a9a9a;
  font-weight: bold;
  letter-spacing: 0.2rem;
}

table {
  border-collapse: collapse;
  max-height: 400px;
  width: 100%;
  font-family: Arial, Helvetica, sans-serif;
  margin-top: 1.5rem;
}

thead {
  font-size: 16px;
  background-color: var(--green);
  color: #fff;
  border-radius: 5px;
}

th {
  padding: 10px;
  border-top: none;
  border-left: none;
}

td {
  padding: 10px;
  border-left: none;
  font-size: 14px;
}

.btn {
  display: flex;
  gap: 1rem;
  margin-left: 16px;
  margin-bottom: -11px;
}

.btn button {
  width: 22px;
  height: 22px;
  background: transparent;
}

.input-tamanho {
  width: 100%;
  height: 40px;
  border: none;
  padding: 3px;
}

.maozinha {
  cursor: pointer;
}

.red {
  color: var(--red) !important;
}

.error {
  background: var(--redTransparent);
}

.buttons-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.button3 {
  background: var(--white);
  color: var(--orange);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button3:hover {
  background: var(--orange);
  color: var(--white);
}

.button4 {
  background: var(--white);
  color: var(--blue);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button4:hover {
  background: var(--blue);
  color: var(--white);
}

.filter-content {
  height: 2.8rem;
  width: 200px;
  background-color: var(--white);
  display: flex;
  align-items: center;
  border: 1px solid var(--gray_text);
  border-radius: 5px;
  padding: 0 0 0 5px;
}

.butt {
  background-color: red;
}

.button5 {
  background: var(--white);
  color: var(--green);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button5:hover {
  background: var(--green);
  color: var(--white);
}

@media (max-width: 600px) {
  .inputSearch {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .searchInput input {
    width: 100%;
  }

  .table thead {
    clip: react(0 0 0 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  tbody {
    background: none;
  }

  .table tr {
    border: 1px solid var(--gray_text);
    border-radius: 7px;
    display: block;
    margin-bottom: 2rem;
    padding: 0;
    background: var(--white);
  }

  .table td {
    display: block;
    font-size: 1rem;
    text-align: right;
  }

  .table td::before {
    content: attr(data-label);
    float: left;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.9rem;
  }

  .buttons-group {
    justify-content: flex-end;
  }
}

.modal-header {
  padding: 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
}

.modal-buttons {
  padding: 1rem;
  display: flex;
  justify-content: end;
  width: 100%;
  gap: 1rem;
}

.btn-modal {
  width: 8rem;
  height: 2.2rem;
  color: #fff;
  border-radius: 0.25rem;
  background-color: var(--green);
}

.reprovar {
  background-color: var(--orange);
}

.cancelar {
  background: #ff8c00;
}

.modal-comentario {
  padding: 1rem;
}

.sem-borda {
  font-weight: 600;
  color: var(--orange);
  background-color: transparent;
  text-decoration-line: underline;
}

.modal-comentario textarea {
  border-radius: 0.25rem;
  padding: 0.5rem;
}

.modal-confirmacao {
  padding: 1rem;
  margin-top: 2rem;
  border-top: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confirmacao-buttons {
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
}
</style>
